import React, { Component } from 'react';
import { markFirstTask } from '../onboarding/firstTaskRegistry';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NewBookingPanel from './NewBookingPanel';
import { bookingActions } from '../../_actions/booking.actions';

// Hosts the NewBookingPanel at the router level so the panel (and its
// minimised pill) survive route changes. Reads its lifecycle and seed data
// from the `minimisedBooking` redux slice — which is persisted via the
// existing redux-persist setup, so a browser reload while minimised also
// restores the draft.
//
// Mount in routes.js alongside <MobileTabBar />.
class NewBookingHost extends Component {
  // Bumped on each "open" / "slot retry" so a fresh panel instance starts
  // cleanly. Re-using the same instance would carry stale local state from
  // the previous draft (services loaded against the previous staff, etc.).
  mountKey = 0;
  lastSlotSignature = null;

  handleMinimiseChange = (isMinimised, snapshot) => {
    this.props.dispatch(bookingActions.setMinimisedBooking(isMinimised, snapshot));
  }

  handleClose = () => {
    this.props.dispatch(bookingActions.closeMinimisedBooking());
  }

  handleCreated = (bookingId) => {
    this.props.dispatch(bookingActions.closeMinimisedBooking());
    // DiaryV2 listens for this and refreshes its data in-place. Using a
    // window event keeps the host decoupled from any specific page — any
    // route that cares can listen and react. The id lets the diary bring
    // the new block in, and Bailey say it landed.
    window.dispatchEvent(new CustomEvent('diary:booking-created', { detail: { bookingId: bookingId || null } }));
    markFirstTask('book');
  }

  render() {
    const { active, isMinimised, draft, meta, history, user } = this.props;
    if (!active) return null;

    // Bump the mount key whenever the slot changes — that re-instantiates
    // NewBookingPanel so it picks up the new staff/date/start as initial
    // state. (Without this, switching slots while minimised would not
    // re-load the staff's available services.)
    const sig = `${draft.staffId}|${draft.bookingDate}|${draft.startMinutes}`;
    if (this.lastSlotSignature !== null && this.lastSlotSignature !== sig) {
      this.mountKey += 1;
    }
    this.lastSlotSignature = sig;

    // Prefer the live currency from user state if available — it may have
    // changed since the draft was opened. Fall back to the snapshot.
    const liveCurrency = user?.userInfo?.hairdresser?.currencySymbol;
    const currencySymbol = liveCurrency || meta.currencySymbol || '£';

    return (
      <NewBookingPanel
        key={this.mountKey}
        staffId={draft.staffId}
        bookingDate={draft.bookingDate}
        startMinutes={draft.startMinutes}
        rebookClient={draft.selectedClient}
        newClient={draft.newClient}
        rebookServices={draft.services}
        initialBookingNote={draft.bookingNote}
        initialRepeat={draft.repeat}
        initialMinimised={isMinimised}
        isMinimised={isMinimised}
        staffList={meta.staffList || []}
        currencySymbol={currencySymbol}
        history={history}
        dispatch={this.props.dispatch}
        onClose={this.handleClose}
        onMinimiseChange={this.handleMinimiseChange}
        onCreated={this.handleCreated}
      />
    );
  }
}

function mapStateToProps(state) {
  const slice = state.minimisedBooking || {};
  return {
    active: !!slice.active,
    isMinimised: !!slice.isMinimised,
    draft: slice.draft || {},
    meta: slice.meta || {},
    user: state.user,
  };
}

export default withRouter(connect(mapStateToProps)(NewBookingHost));
